import { call, put, select } from "redux-saga/effects"

import api from "apis"
import { submitCheckoutAppliedPointsEvent } from "helpers/cart"

import { setPaymentMethod, updateOrderData, validatePanels } from "../actions"

export default function* redeemPoints(action) {
  const state = yield select()
  const values = state.checkout.form.hydrated
    ? state.checkout.form.values
    : state.checkout.form.initialValues

  const url = "/secure/api/v10/checkout/reward_points"
  const payload = {
    order_token: values.order_token,
    reward_amount: action.ref?.value || values.reward_amount,
  }

  // Order data to be updated to
  let order_data = {
    coupon_message: null,
    error: null, // error toast message
    gift_card_message: null,
    gift_card_success: false,
    react: state.checkout.order.order,
    shipping_updated: false,
    show_facebook_messenger: false,
  }

  try {
    let result = {}

    try {
      result = yield call(api.put, url, payload)
    } catch (error) {
      result = error
    }

    if (result && result.errors) {
      order_data.reward_error = result.errors[0]
      if (action.setFieldValue) {
        action.setFieldValue("reward_amount", "")
      }
      yield put(updateOrderData(order_data, action.setFieldValue))
      return
    }

    if (result.data.order.reward_adjustment) {
      submitCheckoutAppliedPointsEvent()
    }

    const order_balance = result.data.order_balance || result.data.order.balance
    if (action.setFieldValue) {
      if (order_balance) {
        action.setFieldValue("zip_mismatch_error", false)
        action.setFieldValue("order_balance", order_balance)
        action.setFieldValue("order.balance", order_balance)
      }
      const redeem_value =
        result.data.order.points.redeem_value &&
        Math.round(result.data.order.points.redeem_value) != 0
          ? Math.round(result.data.order.points.redeem_value)
          : ""
      action.setFieldValue("reward_amount", redeem_value)
    }

    order_data.react = {
      ...order_data.react,
      ...result.data.order,
    }

    // Update order data
    yield put(updateOrderData(order_data, action.setFieldValue))

    if (order_balance === "0.0") {
      yield put(setPaymentMethod("jewlr"))
    } else if (state.checkout.order.selectedPaymentMethod === "jewlr") {
      yield put(setPaymentMethod(null))
    }
    yield put(validatePanels(result.data))
  } catch (err) {
    if (action.setFieldValue) {
      action.setFieldValue("reward_amount", "")
    }
    console.log("Error redeeming points", err)
  }
}
